import { CardColor, ToolType } from '~/modules/tools/types';

export enum TOOL {
  CHAT = 'b1fe3e52-7e3f-4789-874a-60805945073e',
  DETECTOR = 'e00dab29-a1b8-416c-ba4e-fc5bb20a2431',
  HUMANIZER = '4656b8a0-d52f-4c08-a4fe-5d2b83b870c0',
  CHECK_PLAGIARISM = '725f820a-5dc4-47c7-a7a5-ddb09cf89c1a',
  PARAPHRASE_TEXT = '8928337a-ca77-4fd2-a161-b5572b508fa5',
  ANALYZE_WEBSITE = '8fd6f39e-c4ae-40d1-bf6f-2e25bd578db4',
  ANALYZE_FILE = 'c89962a1-8ff5-4e23-b7ed-499232d86fc5',
  GRAMMAR_CHECK = '3a72d3d8-77e0-423e-9cf6-de3b346e0235',
  RESEARCHER = 'f6d33993-1bee-45ab-814f-e298e8b7fd58',
  SUMMARIZE_TEXT = '8928337a-ca77-4fd2-a161-b5572b508fa6',
  MEDIUM_ARTICLE = '8928337a-ca77-4fd2-a161-b5572b508fa8',
  LONG_ARTICLE = 'e6bb0a9f-9018-4d50-a166-4b92e641aa5d',
  IMAGE_GENERATOR = '9c5b646e-2b20-463f-a26d-18e422f5275e',
}

export const TOOLS: Record<TOOL, ToolType> = {
  [TOOL.IMAGE_GENERATOR]: {
    id: TOOL.IMAGE_GENERATOR,
    slug: 'image_generation',
    category_id: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    category_name: 'General Writing',
    image_src: '/templates/sidekicker/image_generator.svg',
    path: '/image_generation',
    title: 'Image Generator',
    description: 'An AI-driven image generation',
    tags: [],
    color: CardColor.DEFAULT,
    is_limited: false,
  },
  [TOOL.CHAT]: {
    id: TOOL.CHAT,
    slug: 'chat_assistant',
    category_id: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    category_name: 'General Writing',
    image_src: '/templates/sidekicker/chat.svg',
    path: '/chat/index',
    title: 'AI Chatbot (like ChatGPT)',
    description:
      'But with real-time data, ability to read links, attach files, chat personalities and improved prompts.',
    tags: [],
    color: CardColor.DEFAULT,
    is_limited: false,
  },
  [TOOL.DETECTOR]: {
    id: TOOL.DETECTOR,
    slug: 'ai_content_detector',
    category_id: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    category_name: 'General Writing',
    image_src: '/templates/sidekicker/detector.svg',
    title: 'Detect AI',
    description:
      'Instantly scan text content and detect the AI written text in it',
    tags: [],
    color: CardColor.DEFAULT,
    is_limited: false,
  },
  [TOOL.HUMANIZER]: {
    id: TOOL.HUMANIZER,
    slug: 'ai_text_humanizer',
    category_id: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    category_name: 'General Writing',
    image_src: '/templates/sidekicker/humanizer.svg',
    title: 'Humanize Text',
    description:
      'Turn your content into high quality text that is indistinguishable from human writing',
    tags: [],
    color: CardColor.DEFAULT,
    is_limited: false,
  },
  [TOOL.CHECK_PLAGIARISM]: {
    id: TOOL.CHECK_PLAGIARISM,
    slug: 'plagiarism_checker',
    category_id: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    category_name: 'General Writing',
    image_src: '/templates/sidekicker/check_plagiarism.svg',
    title: 'Check Plagiarism',
    description:
      'Discover originality with our quick plagiarism scanner. Ensure your work shines with uniqueness!',
    tags: [],
    color: CardColor.DEFAULT,
    is_limited: false,
  },
  [TOOL.PARAPHRASE_TEXT]: {
    id: TOOL.PARAPHRASE_TEXT,
    slug: 'paraphrase_text',
    category_id: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    category_name: 'General Writing',
    image_src: '/templates/sidekicker/paraphraser.svg',
    title: 'Paraphrase Text',
    description:
      'Paraphrase your content in a different voice and style. Ideal for essays and short pieces of text.',
    tags: [],
    color: CardColor.DEFAULT,
    is_limited: false,
  },
  [TOOL.ANALYZE_WEBSITE]: {
    id: TOOL.ANALYZE_WEBSITE,
    slug: 'chat_assistant_website',
    path: '/chat/index?is_scraper_site=true',
    category_id: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    category_name: 'General Writing',
    image_src: '/templates/sidekicker/analyze_website.svg',
    title: 'Analyze Website',
    description: 'Paste a link and discuss it with AI',
    tags: [],
    color: CardColor.DEFAULT,
    is_limited: false,
  },
  [TOOL.ANALYZE_FILE]: {
    id: TOOL.ANALYZE_FILE,
    slug: 'chat_assistant_file',
    path: '/chat/index?is_scraper=true',
    category_id: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    category_name: 'General Writing',
    image_src: '/templates/sidekicker/analyze_file.svg',
    title: 'Analyze File',
    description: 'Provide PDF, DOC or TXT file and discuss it with AI',
    tags: [],
    color: CardColor.DEFAULT,
    is_limited: false,
  },
  [TOOL.GRAMMAR_CHECK]: {
    id: TOOL.GRAMMAR_CHECK,
    slug: 'grammar_check',
    category_id: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    category_name: 'General Writing',
    image_src: '/templates/sidekicker/check_grammar.svg',
    title: 'Check Grammar',
    description:
      'Identify and correct grammatical errors to improve clarity, conciseness, and credibility in any written work.',
    tags: [],
    color: CardColor.DEFAULT,
    is_limited: false,
  },
  [TOOL.RESEARCHER]: {
    id: TOOL.RESEARCHER,
    slug: 'ai_researcher',
    path: '/ai_researcher',
    category_id: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    category_name: 'General Writing',
    image_src: '/templates/sidekicker/researcher.svg',
    title: 'Market Researcher',
    description:
      'An AI-powered research assistant designed to streamline the discovery and analysis of information',
    tags: [],
    color: CardColor.DEFAULT,
    is_limited: false,
  },
  [TOOL.SUMMARIZE_TEXT]: {
    id: TOOL.SUMMARIZE_TEXT,
    slug: 'summarize_text',
    category_id: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    category_name: 'General Writing',
    image_src: '/templates/sidekicker/analyze_website.svg',
    title: 'Summarize Text (PDF/DOC)',
    description:
      'Shorten your content and present the key takeaways of a text.',
    tags: [],
    color: CardColor.DEFAULT,
    is_limited: false,
  },
  [TOOL.MEDIUM_ARTICLE]: {
    id: TOOL.MEDIUM_ARTICLE,
    slug: 'generate_article',
    category_id: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    category_name: 'General Writing',
    image_src: '/templates/sidekicker/medium_article.svg',
    title: 'Medium Article (~900 Words)',
    description:
      'Premium quality SEO-friendly blog articles. Choose keywords, tone, CTAs, POV, and length.',
    tags: [],
    color: CardColor.DEFAULT,
    is_limited: false,
  },
  [TOOL.LONG_ARTICLE]: {
    id: TOOL.LONG_ARTICLE,
    slug: 'advanced_article_generator',
    category_id: 'a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11',
    category_name: 'General Writing',
    image_src: '/templates/sidekicker/long_article.svg',
    title: 'Long Article (1,200+ Words)',
    description:
      'Generate long premium articles with 1,000-2,000 words (5-10 min. reading time).',
    tags: [],
    color: CardColor.DEFAULT,
    is_limited: false,
  },
};
